<template>
  <v-autocomplete
    v-model="object"
    :label="itemAction.name"
    :item-text="itemText"
    :items="objects"
    :item-value=" (itemAction.itemValue)? itemAction.itemValue : 'id'"
    :search-input.sync="findObject"
    no-data-text="Sin Resultados"
    :disabled="itemAction.readonly"
    clearable
    outlined
    dense>
      <template v-slot:selection="{ item }">
        <v-list-item-action-text dense>
          <span class="font-weight-bold subtitle-2" >{{ itemText(item) }}</span>
        </v-list-item-action-text>
      </template>

      <template v-slot:item="{ item }">
        <v-list-item-action-text dense>
          <span class="font-weight-bold font-weight-black">{{ itemText(item) }}</span>
        </v-list-item-action-text>
      </template>
  </v-autocomplete>
</template>

<script>
import axios from 'axios'
export default {
  name: 'SearchDinamicField',
  props: ['itemAction', 'onSuccess', 'setterModel'],
  data: () => ({
    object: null,
    objects: [],
    findObject: null
  }),
  mounted () {
    this.setModel(this.setterModel)
  },
  methods: {
    itemText (item) {
      if (item && (this.itemAction.nameid === 'cve_empleado' || this.itemAction.nameid === 'empleado_id')) {
        return `${item.NombreCompleto}`
      } else if (item && this.itemAction.nameid === 'adscripcion_id') {
        return `${item.NombreCompleto} - ${item.departamento} - ${item.categoria}`
      } else if (item && (this.itemAction.nameid === 'departamento_id' || this.itemAction.nameid === 'lugar_nacimiento_id' || this.itemAction.nameid === 'localidad_id')) {
        return `${item.nombre}`
      } else if (item && this.itemAction.nameid === 'ejercicio_id') {
        return `${item.descripcion}`
      } else if (item && this.itemAction.nameid === 'tipo_incidencia_id') {
        return `${item.motivo}`
      }
      return 'No Title'
    },
    getDinamicData (name) {
      const token = this.$cookies.get('token_sirh')
      axios.get(`${this.itemAction.url}/${name}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        this.objects = []
        this.objects.push(...response.data)
      }).catch(error => {
        if (error == null) {}
      })
    },
    postDinamicData (name) {
      const token = this.$cookies.get('token_sirh')
      axios.post(`${this.itemAction.url}`, { name }, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        this.objects = []
        this.objects.push(...response.data)
      }).catch(error => {
        if (error == null) {}
      })
    },
    clearData (e) {
      this.onSuccess({ id: this.itemAction.nameid, data: null })
    },
    setModel (val) {
      if (val) {
        switch (this.itemAction.nameid) {
          case 'cve_empleado':
            if (val.empleado) {
              this.object = val.empleado.cve_empleado
              this.objects.push(val.empleado)
            }
            break
          case 'adscripcion_id':
            if (val.adscripcion) {
              this.object = val.adscripcion.id
              const objectads = {
                id: val.adscripcion.id,
                cve_empleado: val.adscripcion.empleado.cve_empleado,
                NombreCompleto: val.adscripcion.empleado.NombreCompleto,
                departamento: val.adscripcion.departamento.nombre,
                categoria: val.adscripcion.plaza.categoria.nombre
              }
              this.objects.push(objectads)
            }
            break
          case 'departamento_id':
            if (val.departamento) {
              this.object = val.departamento.id
              this.objects.push(val.departamento)
            }
            break
          case 'lugar_nacimiento_id':
            if (val.lugar_nacimiento) {
              this.object = val.lugar_nacimiento.id
              this.objects.push(val.lugar_nacimiento)
            }
            break
          case 'localidad_id':
            if (val.localidad) {
              this.object = val.localidad[this.itemAction.itemValue]
              this.objects.push(val.localidad)
            }
            break
        }
      }
    }
  },
  watch: {
    findObject (val) {
      if (val === null || val === '') return

      if (this.itemAction.method) {
        this.postDinamicData(val.replace(' ', '_'))
      } else {
        this.getDinamicData(val.replace(' ', '_'))
      }
    },
    object (val) {
      this.onSuccess({ id: this.itemAction.nameid, data: val, action: this.itemAction.action, field: this.itemAction })
      // this.onSuccess({ id: this.itemAction.nameid, data: val })
    },
    setterModel (val) {
      if (val) {
        this.setModel(val)
        /*
        switch (this.itemAction.nameid) {
          case 'cve_empleado':
            if (val.empleado) {
              this.object = val.empleado.cve_empleado
              this.objects.push(val.empleado)
            }
            break
          case 'adscripcion_id':
            if (val.adscripcion) {
              this.object = val.adscripcion.id
              val.adscripcion.NombreCompleto = val.adscripcion.empleado.NombreCompleto
              this.objects.push(val.adscripcion)
            }
            break
          case 'departamento_id':
            if (val.departamento) {
              this.object = val.departamento.id
              this.objects.push(val.departamento)
            }
            break
          case 'lugar_nacimiento_id':
            if (val.lugar_nacimiento) {
              console.log(val.lugar_nacimiento)
              this.object = val.lugar_nacimiento.id
              this.objects.push(val.lugar_nacimiento)
            }
            break
        }
        */
      }
    }
  }
}
</script>

<style>

</style>
